// eslint-disable-next-line import/named
import { UserCredential } from 'firebase/auth';
import React, { useState } from 'react';

import { useAuth } from '../../../common/hooks/useAuth';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { useNavigation } from '../../../common/navigation';
import ValidationAlert from '../ValidationAlert';

import { SignIn } from './SignIn';

export type Props = {
  open: boolean;
  onSignIn: (usr: string, pwd: string) => Promise<UserCredential | void>;
};

export const SignInDialog: React.FC<Props> = ({ onSignIn }) => {
  const nav = useNavigation();
  const spdApi = useSpdCore();
  const auth = useAuth();
  const notifications = useNotifications();

  const [showError, setShowError] = useState(false);
  const [errorText, setErrorText] = useState('');

  const handleSignIn = async (usr: string, pwd: string) => {
    onSignIn(usr, pwd)
      .then(uC => {
        if (uC) {
          spdApi.users
            .getMe()
            .then(us => {
              if (us) {
                auth
                  .updateProfile(us)
                  .then(() => {
                    return void nav.startPage();
                  })
                  .catch(error => {
                    if (error.message === 'Failed to fetch') {
                      notifications.noBackend();
                    }
                    console.log(
                      `Wystąpił problem z pobraniem profilu. ${error}`,
                    );
                  });
              } else {
                return void nav.startPage();
              }
            })
            .catch(error => {
              if (error.message === 'Failed to fetch') {
                notifications.noBackend();
              }
              console.log(`Wystąpił problem z pobraniem profilu. ${error}`);
            });
        }
      })
      .catch(err => {
        setErrorText('Błąd podczas logowania: ' + (err as Error).message);
        setShowError(true);
      });
  };

  return (
    <>
      <ValidationAlert
        heading={'LOGOWANIE'}
        variant={'warning'}
        show={showError}
        modal={true}
        onHide={() => {
          setShowError(false);
        }}
        errors={[errorText]}
      />

      <SignIn onSignIn={handleSignIn} />
    </>
  );
};
